(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('AddressDialogController', AddressDialogController);

    AddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'Address', 'Country', 'Runner'];

    function AddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, Address, Country, Runner) {
        var vm = this;

        vm.address = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query({filter: 'address(address)-is-null'});
        $q.all([vm.address.$promise, vm.countries.$promise]).then(function() {
            if (!vm.address.country || !vm.address.country.id) {
                return $q.reject();
            }
            return Country.get({id : vm.address.country.id}).$promise;
        }).then(function(country) {
            vm.countries.push(country);
        });
        vm.runners = Runner.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.address.id !== null) {
                Address.update(vm.address, onSaveSuccess, onSaveError);
            } else {
                Address.save(vm.address, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:addressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
